<template>
  <div class="book-page">
    <div class="page-title">{{ textbookName || "知识点列表" }}</div>
    <el-table :data="knowledges" v-loading="loading" stripe>
      <el-table-column type="expand" width="48">
        <template slot-scope="scope">
          <div
            v-if="scope.row.introduce"
            class="knowledge-introduce"
            v-html="scope.row.introduce"
          ></div>
          <el-empty v-else description="暂无介绍" :image-size="60"></el-empty>
        </template>
      </el-table-column>
      <el-table-column label="单元" width="120">
        <template slot-scope="scope">
          Unit {{ scope.row.unitNo || "-" }}
        </template>
      </el-table-column>
      <el-table-column prop="unitTitle" label="单元标题" min-width="260" />
      <el-table-column prop="knowledgeName" label="知识点" min-width="260" />
      <el-table-column label="VOD地址" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.vodUrl || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="介绍摘要" min-width="280">
        <template slot-scope="scope">
          <span>{{ introduceSummary(scope.row.introduce) || "-" }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBookKnowledgeByTextbook } from "@/api/book";

export default {
  name: "BookKnowledgeIndex",
  data() {
    return {
      loading: false,
      knowledges: [],
      textbookId: null,
      textbookName: ""
    };
  },
  mounted() {
    this.textbookId = this.$route.query.textbookId;
    this.textbookName = this.$route.query.textbookName || "";
    this.loadData();
  },
  methods: {
    introduceSummary(value) {
      if (!value) return "";
      const text = String(value)
        .replace(/<script[\s\S]*?<\/script>/gi, "")
        .replace(/<style[\s\S]*?<\/style>/gi, "")
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/g, " ")
        .trim();
      return text.length > 80 ? `${text.slice(0, 80)}...` : text;
    },
    async loadData() {
      if (!this.textbookId) {
        this.$message.error("教材ID缺失");
        return;
      }
      this.loading = true;
      try {
        const res = await getBookKnowledgeByTextbook(this.textbookId);
        if (res.code === 200 || res.code === 0) {
          this.knowledges = res.data || [];
        } else {
          this.$message.error(res.message || "加载知识点失败");
        }
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.book-page {
  background: #fff;
  padding: 16px;
  border-radius: 10px;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
}
.knowledge-introduce {
  padding: 12px 20px;
  color: #334155;
  line-height: 1.8;
  word-break: break-word;
}
.knowledge-introduce ::v-deep img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}
</style>
